import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormNavigationButtonsComponent } from '../components/form-navigation-buttons/form-navigation-buttons.component';
import { BehaviorSubject, filter, first, firstValueFrom, forkJoin } from 'rxjs';
import { SignupSurveyService, SURVEY_TYPE } from '../../service/signup-survey.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements AfterViewInit, OnInit, OnDestroy {

  @Input() surveyType: string = SURVEY_TYPE.Signup
  @Input() userProfile: any
  config = { animation: true, selectionType: 'multi', selectionLimit: -1 }
  childMethods: any = {}
  surveys: any[] = []
  survey_current_indx = 0
  index$ = new BehaviorSubject<number>(0)
  @ViewChild(FormNavigationButtonsComponent) formNavComponent!: FormNavigationButtonsComponent;
  @ViewChild('scrollableDiv', {static: false}) scrollableDiv!: ElementRef<HTMLDivElement>;
  @ViewChild('highlightText', {static: false}) highlightText!: ElementRef<HTMLDivElement>;

  surveyService = inject(SignupSurveyService)
  updateChildMethods$ = { afterViewInit: new BehaviorSubject<number>(0), surveyUpdate: new BehaviorSubject<number>(0) }
  enableContinue = false
  @Input() fireEvent: boolean = false;

  constructor(private cdRef: ChangeDetectorRef){}

  async ngOnInit(): Promise<void> {
    const res = await firstValueFrom(this.surveyService.getSurvey(this.surveyType))
    if(!res || res.length === 0) return
    this.surveys = res
    this.updateChildMethods$.surveyUpdate.next(new Date().getTime())
    this.index$.subscribe(i => {
      this.updateBackButton(i)
      this.updateViewWithSelectedData(i)
      this.config.selectionLimit = this.surveys[this.survey_current_indx].selectionLimit
      this.surveys[this.survey_current_indx].subHeading = (this.config.selectionLimit > 1) ? `Select up to ${this.config.selectionLimit}` : null
    })

    // updating continue button in child when we got survey data and view is created
    forkJoin([this.updateChildMethods$.surveyUpdate.pipe(filter(x => x != 0), first()),
    this.updateChildMethods$.afterViewInit.pipe(filter(x => x != 0), first())]).subscribe(_ => this.updateContinueButton())
    this.cdRef.detectChanges();
  }

  @HostListener('window:formNavigationButton', ['$event'])
  buttonEvent(event: CustomEvent): void {
    if(this.fireEvent) {
      const e = new CustomEvent('surveyEvent', { detail: { index: this.survey_current_indx, calledFrom: event.detail.calledFrom, surveyLength: this.surveys.length } });
      window.dispatchEvent(e);
    }
  }

  clicked(e: any): void {
    if (e.action === 'back') {
      if (this.survey_current_indx > 0) {
        this.survey_current_indx--
        this.index$.next(this.survey_current_indx)
      } else this.formNavComponent!.handleBackClick()
      return
    }
    if (!this.userProfile.survey) this.userProfile.survey = Array(this.surveys.length).fill(null)

    const answerIds = e?.data?.map((x: any) => x.id)
    this.enableContinue = answerIds.length > 0
    this.userProfile.survey[this.survey_current_indx] = {
      questionId: this.surveys[this.survey_current_indx].que_id,
      surveyId: this.surveys[this.survey_current_indx].surveyId,
      answerIds: answerIds
    }
  }

  ngAfterViewInit(): void {
    this.childMethods.next = this.formNavComponent?.handleContinueClick
    this.childMethods.back = this.formNavComponent?.handleBackClick
    this.updateChildMethods$.afterViewInit.next(new Date().getTime())
    this.cdRef.detectChanges();
  }

  @HostListener('click', ['$event'])
    _detectChange(event: Event): void {
      this.cdRef.detectChanges();
    }

  updateContinueButton(): void {
    if (this.surveys.length > 0) {
      this.formNavComponent!.handleContinueClick = async () => {
        if (this.surveys.length - 1 === this.survey_current_indx) {
            this.formNavComponent.handleContinueClick = this.childMethods.next
          this.formNavComponent.handleContinueClick()
        }
        else
          this.survey_current_indx++
        this.index$.next(this.survey_current_indx)
      };
    }
  }

  updateBackButton(i: number): void {
    if (!this.formNavComponent) return
    if (i > 0)
      this.formNavComponent!.handleBackClick = async () => {
        this.survey_current_indx--
        this.index$.next(this.survey_current_indx)
      };
    else{
        this.formNavComponent!.handleBackClick = this.childMethods.back
    }
  }

  ngOnDestroy(): void {
    this.index$.unsubscribe()
    this.updateChildMethods$.afterViewInit.unsubscribe()
    this.updateChildMethods$.surveyUpdate.unsubscribe()
  }

  updateViewWithSelectedData(i: number): void {
    const response = this.userProfile.survey?.[i]?.answerIds ?? []
    response.forEach((ansId: number) => {
      const currentSurveyOption = this.surveys?.[i]?.options.find((x: any) => x.id === ansId)
      if(currentSurveyOption)
        currentSurveyOption.isSelected = true
    })
    this.enableContinue = response.length > 0
  }
}
